export default "__VITE_ASSET__DBHNUpAM__"